// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import { branch, branchLevelColor, shop, shoppingCenter, zone } from '../../../../const';
import type {
  BranchLevelGemini,
  VisioglobeUnitsOk,
} from '../../../../types/geminiType';
import { getWeighingAvgByZoneName } from './geminiFunctions';

type Props = {
  visioglobeUnits: VisioglobeUnitsOk[],
  branchLevels: BranchLevelGemini[],
  zoneColorMap: Object,
  selectedCategory: string,
  selectedZone: string,
  selectedBranches: string[],
  selectShoppingCenterCat: () => void,
  selectBranchCat: () => void,
  selectZoneCat: () => void,
  selectStoreCat: () => void,
  updateSelectedZone: (string) => void,
  updateSelectedStore: (string, VisioglobeUnitsOk) => void,
  updateSelectedBranchLevel: (string) => void,
  clearFilter: () => void,
  disableAction: boolean,
}

function GeminiPOVFilter(props: Props) {
  return (
    <>
      <div className="top-menu-gemini-cell">
        <div className="data-section-header">
          <Translate value="SIDE_MENU.point_of_view" />
        </div>
        <div className="selector-buttons-row">
          <button
            onClick={() => {
              props.selectShoppingCenterCat();
            }}
            className={`selector-buttons ${props.selectedCategory && props.selectedCategory === shoppingCenter ? 'selected' : ''}`}
            disabled={props.disableAction}
          >
            <Translate value="GEMINI_HEADER.shoppingCenter" />
          </button>
          <button
            onClick={() => props.selectBranchCat()}
            className={`selector-buttons ${props.selectedCategory && props.selectedCategory === branch ? 'down-arrow-selected' : ''}`}
            disabled={props.disableAction}
          >
            <Translate value="GEMINI_HEADER.branch" />
          </button>
          <button
            onClick={() => props.selectZoneCat()}
            className={`selector-buttons ${props.selectedCategory && props.selectedCategory === zone ? 'down-arrow-selected' : ''}`}
            disabled={props.disableAction}
          >
            <Translate value="GEMINI_HEADER.zone" />
          </button>
          <button
            onClick={() => props.selectStoreCat()}
            className={`selector-buttons ${props.selectedCategory && props.selectedCategory === shop ? 'down-arrow-selected' : ''}`}
            disabled={props.disableAction}
          >
            <Translate value="GEMINI_HEADER.shop" />
          </button>
        </div>
      </div>
      <div className="filter-container">
        {
          props.selectedCategory === shop
          && props.visioglobeUnits
            .sort((a, b) => a.storeName.localeCompare(b.storeName))
            .map(store => (
              <button
                key={store.codstr}
                onClick={() =>
                  props.updateSelectedStore(store.idVisioglobes[0], store)}
                className="search-filter"
              >
                <div className="filter-title">
                  {store.storeName}
                </div>
              </button>
            ))
        }
        {
          props.selectedCategory === branch
          && props.branchLevels
            .sort((a, b) => a.branchLevel1Label.localeCompare(b.branchLevel1Label))
            .map(branchLevel => (
              <button
                key={branchLevel.branchLevel1Id}
                onClick={() =>
                  props.updateSelectedBranchLevel(branchLevel.branchLevel1Id)
                }
                className={`search-filter ${props.selectedBranches.includes(branchLevel.branchLevel1Id) ? 'active' : ''}`}
              >
                <div
                  className="filter-title"
                >
                  {branchLevel.branchLevel1Label}
                </div>
                <div
                  className="color-indicator"
                  style={{
                    backgroundColor: branchLevelColor[branchLevel.branchLevel1Id],
                  }}
                />
              </button>
            ))
        }
        {
          props.selectedCategory === zone
          && Object.keys(props.zoneColorMap)
            .sort((a, b) => a.localeCompare(b))
            .map(zoneName => (
              <button
                key={zoneName}
                onClick={() => props.updateSelectedZone(zoneName)}
                className={`search-filter ${props.selectedZone.includes(zoneName) ? 'active' : ''}`}
              >
                <div
                  className="filter-title"
                >
                  {zoneName}
                  <p>(Average
                    weighing: {getWeighingAvgByZoneName(props.visioglobeUnits, zoneName)}%)</p>
                </div>
                <div
                  className="color-indicator"
                  style={{
                    backgroundColor: props.zoneColorMap[zoneName],
                  }}
                />
              </button>
            ))
        }
      </div>
      <div>
        <button
          onClick={props.clearFilter}
          className="apollo-button"
        >
          <Translate value="filters.CLEAR_FILTER" />
        </button>
      </div>
    </>
  );
}

export default GeminiPOVFilter;
